import { Injectable, computed, signal } from '@angular/core';

const TOKEN_STORAGE_KEY = 'fiveworx.communication.accessToken';

/**
 * Holds the JWT issued by the existing external Authenticator Service. This platform
 * never issues its own tokens or collects credentials -- a token arrives via redirect
 * from that service (handled by the auth callback route) and is stored here for the
 * session. See Application & Integration Design's Authorization Strategy: "no new
 * identity model."
 */
@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly tokenSignal = signal<string | null>(sessionStorage.getItem(TOKEN_STORAGE_KEY));

  readonly token = this.tokenSignal.asReadonly();
  readonly isAuthenticated = computed(() => this.tokenSignal() !== null);

  setToken(token: string): void {
    sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
    this.tokenSignal.set(token);
  }

  clearToken(): void {
    sessionStorage.removeItem(TOKEN_STORAGE_KEY);
    this.tokenSignal.set(null);
  }
}
